/* ============================================================
   FALCON — Stoop. Vanilla JS, no dependencies, 60fps, a11y-safe.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.FalconCfg || { settings: {}, strings: {}, routes: {} };
  var S = CFG.settings || {};
  var T = CFG.strings || {};
  var R = CFG.routes || { root: '/', cart: '/cart' };

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fxOn = !!S.animations && !reducedMotion;
  var designMode = !!CFG.designMode || (window.Shopify && window.Shopify.designMode);

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function haptic(ms) {
    if (!S.haptics || reducedMotion) return;
    if (navigator.vibrate) { try { navigator.vibrate(ms || 12); } catch (e) { /* noop */ } }
  }
  function formatMoney(cents) {
    var format = CFG.moneyFormat || '€{{amount}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    var noDec = Math.round(cents / 100).toString();
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key));
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
    return val;
  }

  document.documentElement.classList.remove('no-js');
  if (fxOn) document.body.classList.add('fx-anim');
  if (S.viewTransitions && !reducedMotion) document.documentElement.classList.add('vt-on');

  /* ---------- preloader (once per session) ---------- */
  (function preloader() {
    var el = $('#fx-preloader');
    if (!el) return;
    var seen = sessionStorage.getItem('falcon:preloaded');
    if (seen || reducedMotion || designMode) { el.remove(); return; }
    var done = function () {
      el.classList.add('is-done');
      sessionStorage.setItem('falcon:preloaded', '1');
      setTimeout(function () { el.remove(); }, 300);
    };
    if (document.readyState === 'interactive' || document.readyState === 'complete') setTimeout(done, 60);
    else on(document, 'DOMContentLoaded', function () { setTimeout(done, 60); });
    setTimeout(done, 900);
  })();

  /* ---------- image skeletons ---------- */
  (function skeletons() {
    $$('.img-skel img').forEach(function (img) {
      var wrap = img.closest('.img-skel');
      var markLoaded = function () { if (wrap) wrap.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth > 0) markLoaded();
      else { on(img, 'load', markLoaded); on(img, 'error', markLoaded); }
    });
  })();

  /* ---------- sticky header ---------- */
  (function header() {
    var header = $('[data-header]');
    if (!header) return;
    var mode = header.getAttribute('data-sticky');
    if (mode === 'none') return;
    var lastY = 0, ticking = false;
    var headerH = header.offsetHeight;
    document.body.style.setProperty('--header-h', headerH + 'px');
    function update() {
      var y = window.scrollY;
      if (y > headerH + 40) {
        if (!header.classList.contains('is-stuck')) {
          header.classList.add('is-stuck');
          document.body.style.paddingTop = headerH + 'px';
        }
        if (mode === 'reveal') header.classList.toggle('is-hidden', y > lastY && y > headerH * 3);
      } else if (y <= 2) {
        header.classList.remove('is-stuck', 'is-hidden');
        document.body.style.paddingTop = '';
      }
      lastY = y;
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  })();

  /* ---------- mobile nav & search ---------- */
  (function navToggles() {
    var burger = $('[data-menu-toggle]');
    var nav = $('#MobileNav');
    on(burger, 'click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) nav.removeAttribute('hidden'); else nav.setAttribute('hidden', '');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      haptic(8);
    });
    var searchBtn = $('[data-search-toggle]');
    var search = $('#HeaderSearch');
    on(searchBtn, 'click', function () {
      var open = search.hasAttribute('hidden');
      if (open) {
        search.removeAttribute('hidden');
        var input = $('input[type="search"]', search);
        if (input) input.focus();
      } else search.setAttribute('hidden', '');
      searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  /* ---------- announcement rotation ---------- */
  (function announcement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var msgs = $$('[data-announcement-msg]', bar);
    if (msgs.length < 2) return;
    var interval = (parseInt(bar.getAttribute('data-rotate-interval'), 10) || 4) * 1000;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, interval);
  })();

  /* ---------- hero rotating words ---------- */
  (function heroWords() {
    $$('[data-rotate-words]').forEach(function (wrap) {
      var words = wrap.getAttribute('data-rotate-words').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      if (words.length < 2 || reducedMotion) return;
      var current = $('.hero__word', wrap);
      var i = 0;
      setInterval(function () {
        var next = document.createElement('span');
        next.className = 'hero__word';
        i = (i + 1) % words.length;
        next.textContent = words[i];
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        var old = current;
        setTimeout(function () { old.remove(); }, 500);
        wrap.appendChild(next);
        void next.offsetWidth;
        next.classList.add('is-active');
        current = next;
      }, 2600);
    });
  })();

  /* ---------- kinetic headings (split into words) ---------- */
  (function kinetic() {
    if (!fxOn) return;
    $$('.kinetic').forEach(function (h) {
      if (h.querySelector('.hero__title-rotate')) return;
      var text = h.textContent.trim();
      if (!text || text.length > 90) return;
      var words = text.split(/\s+/);
      h.textContent = '';
      words.forEach(function (w, i) {
        var outer = document.createElement('span');
        outer.className = 'kinetic__word';
        var inner = document.createElement('span');
        inner.className = 'kinetic__inner';
        inner.style.setProperty('--kin-delay', (i * 0.07) + 's');
        inner.textContent = w;
        outer.appendChild(inner);
        h.appendChild(outer);
        if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
      });
    });
  })();

  /* ---------- reveal on scroll ---------- */
  (function reveal() {
    if (!fxOn) return;
    var targets = $$('.reveal, .kinetic').concat(
      $$('.reveal-stagger').reduce(function (acc, wrap) {
        $$(':scope > *', wrap).forEach(function (child, i) {
          child.style.transitionDelay = Math.min(i * 60, 420) + 'ms';
          acc.push(child);
        });
        return acc;
      }, [])
    );
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) { io.observe(t); });
  })();

  /* ---------- parallax ---------- */
  (function parallax() {
    if (!S.parallax || reducedMotion) return;
    var els = $$('[data-parallax]');
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.2;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = 'translateY(' + (progress * speed * -100).toFixed(1) + 'px)';
      });
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* ---------- magnetic buttons (desktop pointer only) ---------- */
  (function magnetic() {
    if (!S.magnetic || reducedMotion) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('[data-magnetic]').forEach(function (btn) {
      var strength = 14;
      on(btn, 'mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = (e.clientX - rect.left - rect.width / 2) / (rect.width / 2);
        var y = (e.clientY - rect.top - rect.height / 2) / (rect.height / 2);
        btn.style.transform = 'translate(' + (x * strength).toFixed(1) + 'px,' + (y * strength * 0.7).toFixed(1) + 'px)';
      });
      on(btn, 'mouseleave', function () { btn.style.transform = ''; });
    });
  })();

  /* ---------- 3D tilt on cards ---------- */
  (function tilt() {
    if (!S.tilt || !fxOn) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var raf = null;
    on(document, 'mousemove', function (e) {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        var card = e.target.closest ? e.target.closest('.product-card, .category-card') : null;
        $$('.is-tilting').forEach(function (c) {
          if (c !== card) { c.classList.remove('is-tilting'); c.style.transform = ''; }
        });
        if (!card) return;
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.classList.add('is-tilting');
        card.style.transform = 'translate(3px, -5px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg)';
      });
    }, { passive: true });
    on(document, 'mouseout', function (e) {
      var card = e.target.closest ? e.target.closest('.product-card, .category-card') : null;
      if (card && !card.contains(e.relatedTarget)) {
        card.classList.remove('is-tilting');
        card.style.transform = '';
      }
    });
  })();

  /* ---------- scroll progress bar ---------- */
  (function progressBar() {
    var bar = $('[data-progress-bar]');
    if (!bar || !S.progressBar) return;
    var ticking = false;
    function update() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* ---------- back to top ---------- */
  (function backTop() {
    var btn = $('[data-back-top]');
    if (!btn) return;
    var ticking = false;
    function update() {
      btn.classList.toggle('is-visible', window.scrollY > 1100);
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    on(btn, 'click', function () {
      haptic(10);
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
    update();
  })();

  /* ---------- fly-to-cart falcon ---------- */
  function flyToCart(fromEl) {
    if (!S.flyToCart || !fxOn || !fromEl) return;
    var cartBtn = $('[data-cart-toggle]');
    if (!cartBtn) return;
    var a = fromEl.getBoundingClientRect();
    var b = cartBtn.getBoundingClientRect();
    var el = document.createElement('span');
    el.className = 'fx-fly';
    el.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><g transform="rotate(38 12 12)"><path d="M23 11.9 11.5 10l-9-.8 2.4 1.2-2.4 1.2 9-.6L23 12.6z"/><path d="M15.6 10.6 4.4 3.8 2 5.6l9.4 5.4z"/><path d="M14.8 13.2 7 17.9l-2-1.2 6.6-4z"/></g></svg>';
    el.style.left = (a.left + a.width / 2 - 13) + 'px';
    el.style.top = (a.top + a.height / 2 - 13) + 'px';
    document.body.appendChild(el);
    void el.offsetWidth;
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    el.style.transform = 'translate(' + dx.toFixed(0) + 'px,' + dy.toFixed(0) + 'px) scale(.3) rotate(-24deg)';
    el.style.opacity = '0';
    setTimeout(function () { el.remove(); }, 900);
  }

  /* ---------- date-driven countdowns ---------- */
  (function countdowns() {
    var els = $$('[data-countdown]');
    if (!els.length) return;
    els.forEach(function (el) {
      var endSec = parseInt(el.getAttribute('data-countdown-end'), 10);
      if (!endSec) { el.remove(); return; }
      var deadline = endSec * 1000;
      var dEl = $('[data-cd-d]', el), hEl = $('[data-cd-h]', el),
          mEl = $('[data-cd-m]', el), sEl = $('[data-cd-s]', el);
      var dCell = $('[data-cd-days-cell]', el), dSep = $('[data-cd-days-sep]', el);
      var timer = null;
      function tick() {
        var left = deadline - Date.now();
        if (left <= 0) {
          if (timer) clearInterval(timer);
          var host = el.closest('.countdown-banner') || el;
          host.remove();
          return;
        }
        var days = Math.floor(left / 86400000);
        var hrs = Math.floor((left % 86400000) / 3600000);
        var min = Math.floor((left % 3600000) / 60000);
        var sec = Math.floor((left % 60000) / 1000);
        if (days > 0) {
          if (dEl) dEl.textContent = String(days);
          if (dCell) dCell.removeAttribute('hidden');
          if (dSep) dSep.removeAttribute('hidden');
        }
        if (hEl) hEl.textContent = String(hrs).padStart(2, '0');
        if (mEl) mEl.textContent = String(min).padStart(2, '0');
        if (sEl) sEl.textContent = String(sec).padStart(2, '0');
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  })();

  /* ---------- overlays (embedded pages) ---------- */
  var Overlay = {
    open: function (slug) {
      var panel = $('[data-overlay-panel="' + slug + '"]');
      if (!panel) return false;
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
      void panel.offsetWidth;
      panel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var closeBtn = $('[data-overlay-close]', panel);
      if (closeBtn && closeBtn.focus) closeBtn.focus();
      haptic(10);
      return true;
    },
    close: function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { panel.setAttribute('hidden', ''); }, 400);
    },
    closeAll: function () {
      $$('.fx-overlay.is-open').forEach(Overlay.close);
    }
  };
  on(document, 'click', function (e) {
    var trigger = e.target.closest('[data-overlay]');
    if (trigger) {
      e.preventDefault();
      Overlay.open(trigger.getAttribute('data-overlay'));
      return;
    }
    var closer = e.target.closest('[data-overlay-close]');
    if (closer) {
      var panel = closer.closest('.fx-overlay');
      if (panel) Overlay.close(panel);
    }
  });
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') {
      Overlay.closeAll();
      var drawer = $('#CartDrawer');
      if (drawer && drawer.classList.contains('is-open')) Cart.closeDrawer();
      var popup = $('#PromoPopup');
      if (popup && popup.classList.contains('is-open')) Popup.close();
    }
  });

  /* ---------- smart 404 ---------- */
  (function smart404() {
    if (document.body.getAttribute('data-template') !== '404') return;
    if (designMode) return;
    var path = window.location.pathname.toLowerCase().replace(/\/+$/, '');
    var map = {
      'privacy-policy': 'privacy', 'privacy': 'privacy',
      'terms': 'terms', 'terms-of-service': 'terms', 'terms-and-conditions': 'terms', 'terms-of-use': 'terms',
      'shipping': 'shipping', 'shipping-policy': 'shipping', 'delivery': 'shipping',
      'refund': 'refund', 'refund-policy': 'refund', 'returns': 'refund', 'return-policy': 'refund',
      'size-guide': 'size-guide', 'sizing': 'size-guide', 'size-chart': 'size-guide',
      'faq': 'faq', 'faqs': 'faq', 'help': 'faq',
      'about': 'about', 'about-us': 'about', 'our-story': 'about',
      'contact': 'contact', 'contact-us': 'contact', 'support': 'contact'
    };
    var m = path.match(/\/pages\/([a-z0-9-]+)/);
    if (m && map[m[1]]) {
      if (Overlay.open(map[m[1]])) return;
    }
    try {
      var guardKey = 'falcon:404guard';
      var last = parseInt(sessionStorage.getItem(guardKey) || '0', 10);
      var now = Date.now();
      if (now - last < 15000) return;
      sessionStorage.setItem(guardKey, String(now));
    } catch (e) { return; }
    var note = $('[data-404-redirect]');
    if (note) note.removeAttribute('hidden');
    setTimeout(function () { window.location.replace(R.root || '/'); }, 2600);
  })();

  /* ---------- CART ---------- */
  var Cart = {
    state: null,
    prevTotal: null,

    fetchCart: function () {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.state = cart; Cart.render(); return cart; });
    },

    add: function (id, qty) {
      return fetch(R.cartAdd || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      }).then(function () {
        haptic(18);
        return Cart.fetchCart().then(function () { Cart.openDrawer(); });
      });
    },

    change: function (line, qty) {
      return fetch(R.cartChange || '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { Cart.state = cart; Cart.render(); });
    },

    render: function () {
      var cart = Cart.state;
      if (!cart) return;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
        el.classList.add('is-bumped');
        setTimeout(function () { el.classList.remove('is-bumped'); }, 350);
      });
      var drawerCount = $('[data-cart-count-drawer]');
      if (drawerCount) drawerCount.textContent = cart.item_count;

      var itemsWrap = $('[data-cart-items]');
      var emptyWrap = $('[data-cart-empty]');
      var foot = $('[data-cart-foot]');
      var upsell = $('[data-cart-upsell]');
      if (!itemsWrap) return;

      if (cart.item_count === 0) {
        itemsWrap.innerHTML = '';
        if (emptyWrap) emptyWrap.removeAttribute('hidden');
        if (foot) foot.setAttribute('hidden', '');
        if (upsell) upsell.setAttribute('hidden', '');
      } else {
        if (emptyWrap) emptyWrap.setAttribute('hidden', '');
        if (foot) foot.removeAttribute('hidden');
        if (upsell) upsell.removeAttribute('hidden');
        itemsWrap.innerHTML = cart.items.map(function (item, i) {
          var img = item.image
            ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_180x$1$2')
            : '';
          return '<div class="cart-item wing-cut" data-line="' + (i + 1) + '">' +
            '<a class="cart-item__media img-skel is-loaded" href="' + esc(item.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" width="76" height="90" loading="lazy">' : '') +
            '</a>' +
            '<div>' +
              '<a class="cart-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              (item.variant_title ? '<p class="cart-item__variant">' + esc(item.variant_title) + '</p>' : '') +
              '<p class="cart-item__price">' + formatMoney(item.final_price) + '</p>' +
              '<div class="cart-item__qty"><div class="qty">' +
                '<button type="button" class="qty__btn" data-line-minus aria-label="-">&minus;</button>' +
                '<input class="qty__input" type="number" min="0" value="' + item.quantity + '" data-line-qty aria-label="Qty">' +
                '<button type="button" class="qty__btn" data-line-plus aria-label="+">+</button>' +
              '</div></div>' +
              '<button type="button" class="cart-item__remove" data-line-remove>' + esc(T.remove || 'Remove') + '</button>' +
            '</div>' +
            '<span class="cart-item__line">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>';
        }).join('');
      }

      var subtotal = $('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      Cart.renderShipBar(cart);
      Cart.prevTotal = cart.total_price;
    },

    renderShipBar: function (cart) {
      var bar = $('#CartDrawer [data-ship-bar]');
      if (!bar) return;
      var threshold = S.freeShippingThreshold || 0;
      if (!threshold) return;
      var fill = $('[data-ship-fill]', bar);
      var glyph = $('[data-ship-glyph]', bar);
      var text = $('[data-ship-text]', bar);
      var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
      if (fill) fill.style.width = pct + '%';
      if (glyph) glyph.style.left = pct + '%';
      if (text) {
        if (cart.total_price >= threshold) {
          text.innerHTML = '<b>' + esc(T.freeShippingUnlocked || '') + '</b>';
          if (Cart.prevTotal !== null && Cart.prevTotal < threshold && S.confetti) Cart.confetti();
        } else {
          var remaining = formatMoney(threshold - cart.total_price);
          text.innerHTML = esc(T.freeShippingProgress || '[amount]').replace('[amount]', '<b>' + remaining + '</b>');
        }
      }
    },

    confetti: function () {
      if (reducedMotion) return;
      var canvas = $('[data-confetti-canvas]');
      if (!canvas) return;
      var panel = canvas.parentElement;
      canvas.width = panel.offsetWidth;
      canvas.height = panel.offsetHeight;
      var ctx = canvas.getContext('2d');
      var colors = ['#FF4D1C', '#F1EDE5', '#8C9BAB'];
      var parts = [];
      for (var i = 0; i < 90; i++) {
        parts.push({
          x: Math.random() * canvas.width,
          y: -20 - Math.random() * canvas.height * 0.4,
          w: 5 + Math.random() * 6,
          h: 3 + Math.random() * 4,
          vy: 2.4 + Math.random() * 3.2,
          vx: -1.4 + Math.random() * 2.8,
          rot: Math.random() * Math.PI,
          vr: -0.14 + Math.random() * 0.28,
          color: colors[i % colors.length]
        });
      }
      var frames = 0;
      haptic([16, 40, 16]);
      (function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        parts.forEach(function (p) {
          p.x += p.vx; p.y += p.vy; p.rot += p.vr;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          ctx.restore();
        });
        frames++;
        if (frames < 170) window.requestAnimationFrame(draw);
        else ctx.clearRect(0, 0, canvas.width, canvas.height);
      })();
    },

    openDrawer: function () {
      var drawer = $('#CartDrawer');
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    closeDrawer: function () {
      var drawer = $('#CartDrawer');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  (function cartInit() {
    var drawer = $('#CartDrawer');
    if (drawer) {
      on(document, 'click', function (e) {
        if (e.target.closest('[data-cart-toggle]')) {
          e.preventDefault();
          Cart.fetchCart().then(Cart.openDrawer);
        }
        if (e.target.closest('#CartDrawer [data-drawer-close]')) Cart.closeDrawer();
        var upsellBtn = e.target.closest('[data-upsell-add]');
        if (upsellBtn) {
          upsellBtn.disabled = true;
          flyToCart(upsellBtn);
          Cart.add(parseInt(upsellBtn.getAttribute('data-upsell-add'), 10), 1)
            .then(function () { upsellBtn.disabled = false; })
            .catch(function () { upsellBtn.disabled = false; });
        }
        var line = e.target.closest('.cart-item');
        if (line) {
          var lineNo = parseInt(line.getAttribute('data-line'), 10);
          var qtyInput = $('[data-line-qty]', line);
          var qty = parseInt(qtyInput.value, 10) || 0;
          if (e.target.closest('[data-line-plus]')) Cart.change(lineNo, qty + 1);
          if (e.target.closest('[data-line-minus]')) Cart.change(lineNo, Math.max(0, qty - 1));
          if (e.target.closest('[data-line-remove]')) Cart.change(lineNo, 0);
        }
      });
      on(document, 'change', function (e) {
        if (e.target.matches('[data-line-qty]')) {
          var line = e.target.closest('.cart-item');
          Cart.change(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
        }
      });
      Cart.fetchCart();
    }

    on(document, 'submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form || !drawer) return;
      e.preventDefault();
      var btn = $('[data-add-to-cart]', form);
      var textEl = $('[data-atc-text]', form);
      var origin = textEl ? textEl.textContent : '';
      var idInput = $('[data-variant-input]', form) || $('[name="id"]', form);
      var qtyInput = $('[name="quantity"]', form);
      if (btn) btn.disabled = true;
      flyToCart(btn);
      Cart.add(parseInt(idInput.value, 10), parseInt(qtyInput ? qtyInput.value : '1', 10) || 1)
        .then(function () {
          if (textEl) {
            textEl.textContent = T.added || 'Added';
            setTimeout(function () { textEl.textContent = origin; }, 1800);
          }
          if (btn) btn.disabled = false;
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          form.submit();
        });
    });
  })();

  /* ---------- PDP ---------- */
  (function pdp() {
    var wrap = $('[data-product-wrap]');
    if (!wrap) return;

    var track = $('[data-gallery-track]', wrap);
    var dots = $$('[data-gallery-dot]', wrap);
    var thumbs = $$('[data-gallery-thumb]', wrap);
    if (track) {
      var slides = $$('[data-gallery-slide]', wrap);
      var setActive = function (idx) {
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      };
      on(track, 'scroll', function () {
        window.requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / track.offsetWidth);
          setActive(Math.max(0, Math.min(idx, slides.length - 1)));
        });
      }, { passive: true });
      var goTo = function (idx) {
        track.scrollTo({ left: idx * track.offsetWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
        setActive(idx);
      };
      dots.forEach(function (d) { on(d, 'click', function () { goTo(parseInt(d.getAttribute('data-gallery-dot'), 10)); }); });
      thumbs.forEach(function (t) { on(t, 'click', function () { goTo(parseInt(t.getAttribute('data-gallery-thumb'), 10)); }); });
    }

    var variantJsonEl = $('[data-variant-json]');
    var variants = [];
    try { variants = JSON.parse(variantJsonEl.textContent); } catch (e) { variants = []; }
    var optionInputs = $$('[data-option-input]', wrap);
    var variantInput = $('[data-variant-input]', wrap);
    var priceEl = $('[data-price]', wrap);
    var compareEl = $('[data-compare]', wrap);
    var saveBadge = $('[data-save-badge]', wrap);
    var atcBtn = $('[data-add-to-cart]', wrap);
    var atcText = $('[data-atc-text]', wrap);
    var stickyPrice = $('[data-sticky-price]');
    var stickyAdd = $('[data-sticky-add]');

    function selectedOptions() {
      var opts = [];
      $$('.option-group', wrap).forEach(function (group) {
        var checked = $('input:checked', group);
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }
    function updateVariant() {
      if (!variants.length) return;
      var v = findVariant(selectedOptions());
      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcText) atcText.textContent = T.unavailable || 'Unavailable';
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) {
        if (onSale) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.removeAttribute('hidden'); }
        else compareEl.setAttribute('hidden', '');
      }
      if (saveBadge) {
        if (onSale) {
          saveBadge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          saveBadge.removeAttribute('hidden');
        } else saveBadge.setAttribute('hidden', '');
      }
      var available = v.available;
      if (atcBtn) atcBtn.disabled = !available;
      if (stickyAdd) stickyAdd.disabled = !available;
      if (atcText) atcText.textContent = available ? (T.addToCart || 'Add to cart') : (T.soldOut || 'Sold out');
      priceEl && priceEl.classList.toggle('price--sale', !!onSale);
    }
    optionInputs.forEach(function (input) { on(input, 'change', function () { haptic(6); updateVariant(); }); });
    if (variants.length) updateVariant();

    on(document, 'click', function (e) {
      var qtyWrap = e.target.closest('[data-qty]');
      if (!qtyWrap) return;
      var input = $('.qty__input', qtyWrap);
      var val = parseInt(input.value, 10) || 1;
      if (e.target.closest('[data-qty-plus]')) input.value = val + 1;
      if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, val - 1);
    });

    var sticky = $('[data-sticky-atc]');
    var mainBtn = $('[data-add-to-cart]', wrap);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      sticky.removeAttribute('hidden');
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' });
      io.observe(mainBtn);
      on(stickyAdd, 'click', function () {
        mainBtn.closest('form').dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }

    // Fabricated scarcity removed: stock counts and "live viewers" were random numbers.
    var stock = $('[data-stock-scale]', wrap);
    if (stock) stock.remove();
    var viewers = $('[data-live-viewers]', wrap);
    if (viewers) viewers.remove();

    var productJsonEl = $('[data-product-json]');
    if (productJsonEl) {
      try {
        var p = JSON.parse(productJsonEl.textContent);
        var list = store('falcon:rv') || [];
        list = list.filter(function (item) { return item.id !== p.id; });
        list.unshift(p);
        store('falcon:rv', list.slice(0, 8));
      } catch (e) { /* noop */ }
    }

    var rec = $('[data-recommendations]');
    if (rec && rec.getAttribute('data-rec-url')) {
      fetch(rec.getAttribute('data-rec-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.querySelector('.product-card')) {
            rec.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () { /* keep demo placeholder */ });
    }
  })();

  /* ---------- recently viewed rendering ---------- */
  (function recentlyViewed() {
    var section = $('[data-recently-viewed]');
    if (!section) return;
    var list = store('falcon:rv') || [];
    var currentId = null;
    var wrapEl = $('[data-product-wrap]');
    if (wrapEl) currentId = parseInt(wrapEl.getAttribute('data-product-id'), 10);
    list = list.filter(function (p) { return p.id !== currentId; });
    if (!list.length) return;
    var row = $('[data-rv-row]', section);
    row.innerHTML = list.slice(0, 4).map(function (p) {
      return '<article class="product-card wing-cut"><a class="product-card__link" href="' + esc(p.url) + '">' +
        '<div class="product-card__media img-skel is-loaded">' +
          (p.image ? '<img class="product-card__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="400" height="500" loading="lazy">' : '') +
        '</div>' +
        '<div class="product-card__info"><h3 class="product-card__title">' + esc(p.title) + '</h3>' +
        '<div class="product-card__price"><span class="price">' + formatMoney(p.price) + '</span></div></div>' +
      '</a></article>';
    }).join('');
    section.removeAttribute('hidden');
  })();

  /* ---------- promo popup ---------- */
  var Popup = {
    el: null,
    open: function () {
      Popup.el.removeAttribute('hidden');
      void Popup.el.offsetWidth;
      Popup.el.classList.add('is-open');
      haptic(10);
    },
    close: function () {
      Popup.el.classList.remove('is-open');
      setTimeout(function () { Popup.el.setAttribute('hidden', ''); }, 400);
      var key = S.popupFrequency === 'session' ? 'falcon:popup:session' : 'falcon:popup:day';
      if (S.popupFrequency === 'session') sessionStorage.setItem(key, '1');
      else store(key, Date.now());
    }
  };
  (function popupInit() {
    Popup.el = $('#PromoPopup');
    if (!Popup.el || !S.popup || designMode) return;
    var seen = S.popupFrequency === 'session'
      ? sessionStorage.getItem('falcon:popup:session')
      : (function () {
          var last = store('falcon:popup:day');
          return last && (Date.now() - last < 86400000);
        })();
    if (seen) return;
    setTimeout(Popup.open, (S.popupDelay || 6) * 1000);

    on(Popup.el, 'click', function (e) {
      if (e.target.closest('[data-popup-close]')) Popup.close();
      if (e.target.closest('[data-popup-shop]')) Popup.close();
      var copyBtn = e.target.closest('[data-copy-code]');
      if (copyBtn) {
        var code = copyBtn.getAttribute('data-code');
        var label = $('[data-copy-label]', copyBtn);
        var done = function () {
          haptic(14);
          if (label) {
            var orig = label.innerHTML;
            label.textContent = T.copied || 'Copied!';
            setTimeout(function () { label.innerHTML = orig; }, 1600);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (err) { /* noop */ }
          ta.remove();
          done();
        }
      }
    });

    // Evergreen popup timer removed: it reset itself on every visit.
    var timerEl = $('[data-popup-timer]', Popup.el);
    if (timerEl) timerEl.remove();
  })();

  /* ---------- sales toasts (disabled: purchases were randomly generated) ---------- */
  (function salesToasts() {
    var toast = $('[data-sales-toast]');
    if (toast) toast.remove();
  })();

  /* ---------- collection sort ---------- */
  (function sortSelect() {
    var select = $('[data-sort-select]');
    if (!select) return;
    on(select, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  })();

  /* ---------- locale selector ---------- */
  (function localeSelect() {
    var select = $('[data-locale-select]');
    if (!select) return;
    on(select, 'change', function () { select.closest('form').submit(); });
  })();

  /* ---------- auth: login/recover toggle ---------- */
  (function authToggles() {
    var loginView = $('[data-login-view]');
    var recoverView = $('[data-recover-view]');
    if (!loginView || !recoverView) {
      // still handle recover hash deep-link absence
    } else {
      on(document, 'click', function (e) {
        if (e.target.closest('[data-show-recover]')) {
          loginView.setAttribute('hidden', '');
          recoverView.removeAttribute('hidden');
        }
        if (e.target.closest('[data-show-login]')) {
          recoverView.setAttribute('hidden', '');
          loginView.removeAttribute('hidden');
        }
      });
      if (window.location.hash === '#recover') {
        loginView.setAttribute('hidden', '');
        recoverView.removeAttribute('hidden');
      }
    }
  })();

  /* ---------- addresses page ---------- */
  (function addresses() {
    var toggle = $('[data-address-new-toggle]');
    var formWrap = $('[data-address-new]');
    if (toggle && formWrap) {
      on(toggle, 'click', function () {
        if (formWrap.hasAttribute('hidden')) formWrap.removeAttribute('hidden');
        else formWrap.setAttribute('hidden', '');
      });
    }
    var country = $('[data-address-country]');
    var provinceWrap = $('[data-province-wrap]');
    var province = $('[data-address-province]');
    if (country && province) {
      var def = country.getAttribute('data-default');
      if (def) {
        $$('option', country).forEach(function (opt) {
          if (opt.value === def) opt.selected = true;
        });
      }
      var updateProvinces = function () {
        var opt = country.options[country.selectedIndex];
        var raw = opt ? opt.getAttribute('data-provinces') : null;
        var provinces = [];
        try { provinces = raw ? JSON.parse(raw) : []; } catch (e) { provinces = []; }
        province.innerHTML = provinces.map(function (pr) {
          return '<option value="' + esc(pr[0]) + '">' + esc(pr[1]) + '</option>';
        }).join('');
        if (provinceWrap) {
          if (provinces.length) provinceWrap.removeAttribute('hidden');
          else provinceWrap.setAttribute('hidden', '');
        }
      };
      on(country, 'change', updateProvinces);
      updateProvinces();
    }
    $$('[data-address-delete]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        var msg = btn.getAttribute('data-confirm') || 'Delete?';
        if (!window.confirm(msg)) e.preventDefault();
      });
    });
  })();

  /* ---------- normalize legacy home links ---------- */
  (function fixHomeLinks() {
    $$('a[href="/pages/home"], a[href="/pages/homepage"]').forEach(function (a) {
      a.setAttribute('href', R.root || '/');
    });
  })();

})();